import AuthStore from 'auth-store';
import history from 'setup/history';
import { req } from 'react-reqq-lite';
import { toastSuccess } from 'react-geek-toast';
import { persistStorage, storage } from 'helper';
import { closeModal } from 'partial/components/Modal';
// eslint-disable-next-line import/no-cycle
import { openChangePassword } from './modals/ChangePasswordModal';
import { getUserTypeFromToken } from './transformers';
import * as t from './transformers';
import * as c from './constants';

export const register = (payload, onSuccess, onError) => {
  req.post({
    key: c.REGISTER,
    url: '/auth/v1/register/initiate',
    payload,
    onSuccess: (res) => {
      if (typeof onSuccess === 'function') onSuccess(res?.response?.data);
    },
    onError,
  });
};

export const login = (payload, onSuccess, onError) => {
  req.post({
    key: c.LOGIN,
    url: '/auth/v1/login',
    payload,
    onSuccess: (res) => {
      const { token, role } = res?.response;
      AuthStore.set('_token', token);
      AuthStore.set('_role', role);
      req.set(c.AUTHENTICATION, {
        isAuthenticated: true,
        userType: getUserTypeFromToken(token),
      });
      if (typeof onSuccess === 'function') onSuccess(res);
      toastSuccess('Login Successful');
      history.push('/');
    },
    onError,
  });
};

export const logout = () => {
  AuthStore.remove('_token');
  AuthStore.remove('_role');
  const activeAccount = persistStorage.get('selected-account');
  if (activeAccount?.id) storage.set('prev-auth-id', activeAccount?.id);
  persistStorage.remove('selected-account');
  storage.remove('onboarding-step');
  closeModal();
  req.reset();
  req.set(c.AUTHENTICATION, {
    isAuthenticated: false,
    userType: null,
  });
};

export const getProfile = (setter) => {
  req.get({
    key: c.PROFILE,
    url: '/auth/v1/my/account',
    transform: (res) => t.transformProfile(res?.data),
    onSuccess: (res) => {
      const profile = t.transformProfile(res?.response?.data);
      setter(profile);
    },
  });
};

export const changePassword = (payload, onSuccess, onError) => {
  req.post({
    key: c.CHANGE_PASSWORD,
    url: '/auth/v1/change_password',
    payload,
    onSuccess: () => {
      toastSuccess('Password changed successfully!');
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError,
  });
};

export const switchProfile = (payload, onSuccess, onError) => {
  req.post({
    key: c.PROFILE,
    url: '/auth/v1/my/account/switch_environment',
    payload,
    onSuccess: (res) => {
      if (typeof onSuccess === 'function') onSuccess(res);
      const token = res?.response?.token;
      const prevToken = AuthStore.get('_token');
      AuthStore.set('_token', token);
      req.set(c.AUTHENTICATION, {
        isAuthenticated: true,
        userType: getUserTypeFromToken(token),
      });
      if (+res?.response?.user?.is_first_time_login === 1) {
        openChangePassword(
          { old_password: payload.password },
          () => {
            window.location.reload();
          },
          () => {
            AuthStore.set('_token', prevToken);
            window.location.reload();
          }
        );
        return;
      }
      window.location.reload();
    },
    onError,
  });
};

export const getCurrentAccount = () => {
  req.get({
    key: c.CURRENT_ACCOUNT,
    url: '/organization/v1/my/organization/current',
    transform: (res) => t.transformAccount(res?.data),
  });
};

export const createAccount = (payload, onSuccess, onError) => {
  req.post({
    key: c.CREATE_ACCOUNT,
    url: '/profile/v1/my/merchants',
    payload,
    onSuccess: (res) => {
      if (typeof onSuccess === 'function') {
        window.location.href = '/';
        persistStorage.set(
          'selected-account',
          t.transformAccount(res?.response?.data)
        );
        onSuccess(res);
      }
    },
    onError,
  });
};

export const toggleAccount = (id, payload, onSuccess, onError) => {
  req.put({
    key: c.TOGGLE_MODE,
    url: `/profile/v1/my/merchants/${id}/toggle_status`,
    payload,
    onSuccess: (res) => {
      toastSuccess('Updated!');
      // getMyAccount(id);
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};

export const updateAccount = (payload, onSuccess, onError) => {
  req.put({
    key: c.CURRENT_ACCOUNT,
    url: '/organization/v1/my/organization/current',
    payload: t.payloadAccount(payload),
    onSuccess: (res) => {
      getCurrentAccount();
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};

export const resendEmailVerification = (id, onSuccess, onError) => {
  req.post({
    key: c.RESEND_EMAIL_VERIFICATION,
    url: `/auth/v1/otp/${id}/resend`,
    onSuccess: ({ response }) => {
      toastSuccess('Email has been resent.');
      if (typeof onSuccess === 'function') {
        onSuccess(response);
      }
    },
    onError: () => {
      if (typeof onError === 'function') {
        onError();
      }
    },
  });
};

/* FORGOT PASSWORD START */
export const forgotPasswordSendEmailInstruction = (callback) => (
  payload,
  inlineCallback,
  inlineErrorCallback
) => {
  req.post({
    key: c.FORGOT_PASSWORD_SEND,
    url: '/auth/v1/forgot_password/sent',
    payload,
    onSuccess: () => {
      if (typeof callback === 'function') callback();
      if (typeof inlineCallback === 'function') inlineCallback();
    },
    onError: (err) => {
      if (typeof inlineErrorCallback === 'function') inlineErrorCallback(err);
    },
  });
};

export const forgotPasswordSetNewPassword = (callback) => (
  payload,
  inlineCallback
) => {
  req.post({
    key: c.FORGOT_PASSWORD_SET,
    url: '/auth/v1/change_password',
    payload,
    onSuccess: () => {
      if (typeof callback === 'function') callback();
      if (typeof inlineCallback === 'function') inlineCallback();
    },
  });
};

export const validateForgotPassword = (payload, onSuccess, onError) => {
  req.post({
    key: c.VALIDATE_FORGOT_PASSWORD,
    payload,
    url: '/auth/v1/forgot_password/check',
    onSuccess: (res) => {
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};
/* FORGOT PASSWORD END */
